import React, { useState, useEffect } from 'react'
import { useTranslation } from 'i18n'
import { SxStyleProp } from 'rebass'
import { useSTheme } from '../../../styles/theme'
import SText from '../../opinionless/SText'
import { objectsEqual } from '../../../utils/objects'
import { error } from '../styles'

interface Props {
    children?: React.ReactNode
    forElementId: string
    sx?: SxStyleProp
    id: string
}

const FInputError: React.FC<Props> = (props: Props) => {
    const theme = useSTheme()
    const fontFamily = theme.fontsV2[window.ORGANIZATION.name]?.body || theme.fontsV2.default
    const fontWeight = theme.fontWeights.medium

    const { children, forElementId, sx = {} } = props
    const [forElement, setForElement] = useState<HTMLElement | null>(null)
    const [coords, setCoords] = useState<{
        left: number
        right: number
        width: number
        top: number
    } | null>(null)

    const { t } = useTranslation(window.LANG_NS)

    const ele = document.getElementById(forElementId)

    const onResize = () => {
        setCoords({
            left: ele?.offsetLeft,
            right: ele?.offsetLeft + ele?.offsetWidth,
            width: ele?.offsetWidth,
            top: ele?.offsetTop + ele?.offsetHeight,
        })
    }

    useEffect(() => {
        const c = {
            left: ele?.offsetLeft,
            right: ele?.offsetLeft + ele?.offsetWidth,
            width: ele?.offsetWidth,
            top: ele?.offsetTop + ele?.offsetHeight,
        }
        // @ts-ignore
        if (!objectsEqual(coords, c)) {
            onResize()
        }
    })

    useEffect(() => {
        if (forElementId) {
            setForElement(ele)
            window.addEventListener('resize', onResize)
            return () => {
                window.removeEventListener('resize', onResize)
            }
        }
    }, [forElementId, t, props.children])

    if (!forElement) return null

    return (
        coords && (
            <SText
                id={props.id}
                fontSize={10}
                color={error.color}
                fontFamily={fontFamily}
                fontWeight={fontWeight}
                sx={{
                    textAlignLast: 'left',
                    whiteSpace: 'pre-line',
                    position: 'absolute',
                    marginTop: 2,
                    left: coords.left,
                    right: coords.right,
                    width: coords.width,
                    top: coords.top,
                    ...sx,
                }}
            >
                {children}
            </SText>
        )
    )
}
export default FInputError
